import type { ReleaseHistory } from './collection.js'

export const ACTIVITY_TYPES = ['listened', 'liked', 'rated', 'added'] as const
export type ActivityType = (typeof ACTIVITY_TYPES)[number]

export interface SocialUserSummary {
	id: string
	username: string
	avatarUrl: string | null
	initials: string
}

export interface ActivityReleaseSummary {
	validUntil?: string | null
	id: number
	title: string
	artists: string[]
	coverImage: string | null
	year: number | null
	uri: string
	owned: boolean
	instanceId?: number
	rating?: number | null
	isFavorite?: boolean
	history?: ReleaseHistory | null
}

export interface ActivityFeedItem {
	id: string
	type: ActivityType
	actor: SocialUserSummary
	release: ActivityReleaseSummary
	occurredAt: string
	rating?: number
}

export interface ActivityFeedResponse {
	items: ActivityFeedItem[]
	nextCursor: string | null
	hasFriends: boolean
}

export type FriendshipState = 'incoming' | 'outgoing' | 'friend'

export interface FriendshipSummary {
	id: string
	state: FriendshipState
	user: SocialUserSummary
}

export interface FriendsResponse {
	friends: FriendshipSummary[]
	incoming: FriendshipSummary[]
	outgoing: FriendshipSummary[]
}
